import { render, staticRenderFns } from "./ProjectApplicant.vue?vue&type=template&id=494a25f6&scoped=true&"
import script from "./ProjectApplicant.vue?vue&type=script&lang=js&"
export * from "./ProjectApplicant.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-applicant.scss?vue&type=style&index=0&id=494a25f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a25f6",
  null
  
)

export default component.exports